import { render } from "./mvt-overlay.vue?vue&type=template&id=e70e6eca"
import script from "./mvt-overlay.js?vue&type=script&lang=js"
export * from "./mvt-overlay.js?vue&type=script&lang=js"

import "./mvt-overlay.vue?vue&type=style&index=0&id=e70e6eca&lang=scss"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__